export function addNexusRedemptionDetails(redemptionDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_NEXUS_REDEMPTION_DETAIL',
                payload: redemptionDetails
            });
            resolve(true)
        });
    }
};

export function updateFullNexusCheckout(redemptionDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_FULL_CART_NEXUS_REDEMPTION',
                payload: redemptionDetails
            });
            resolve(true)
        });
    }
};

export function updateNexusRedeemedAmountCartValueComparisonAcknowledge(redemptionDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_NEXUS_REDEEMED_AMOUNT_CART_VALUE_COMPARISON_ACKNOWLEDGE',
                payload: redemptionDetails
            });
            resolve(true)
        });
    }
};

export function updateNexusRedeemedAmount(redeemedAmount) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_NEXUS_REDEEMED_AMOUNT',
                payload: redeemedAmount
            });
            resolve(true)
        });
    }
};

export function successNexusRedemption(status) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'SUCCESS_NEXUS_REDEMPTION',
                payload: status
            });
            resolve(true)
        });
    }
};

export function resetNexusRedemption() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'RESET_NEXUS_REDEMPTION'
            });
            resolve(true)
        });
    }
};